<template>
  <div class="userindex">
    <div class="van-content">
      <div  style="background-color: #fff" class="userbanner" >
        <div class="userbox">
          <img :src='usertype==1?"/static/images/success.png":"/static/images/false.png"'/>
          <div>
            <p style="color: #333;margin-top: 10px;font-size: 1.6rem">{{ usertype==1?`恭喜您获得${point}积分`:'非工会会员不能获得阅读原文积分奖励' }}</p>
          </div>
        </div>
      </div>

      <van-cell-group class="contolButton">
        <van-cell><router-link to="/user"><van-button size="large"> 积分兑换</van-button></router-link></van-cell>
        <van-cell><router-link to="/user/mymoney"><van-button size="large"> 查看我的积分</van-button></router-link></van-cell>
      </van-cell-group>

      <van-cell-group v-if="(readlist!=''|| readlist!='undefined')&&usertype==1"  style="margin-top: 8px">
        <router-link to="" class="van-cell van-hairline">
          <div class="van-cell__title">
            <span>还有未领取的积分</span>
          </div>
        </router-link>
        <div  v-for="(items,index) in readlist" :key="index">
          <div @click="go(items.link)" class="van-cell van-hairline">
            <!--<router-link :href="items.link"  class="van-cell van-hairline">-->
                <div class="van-cell__title">
                  <span>{{items.title}}</span>
                </div>
                <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
            <!--</router-link>-->
          </div>
        </div>

      </van-cell-group>




    </div>
  </div>
</template>

<script>
  import FooterNav from '@/components/footernav'
  export default {
    name: "read",
    computed:{
      usertype(){
        return this.$store.state.userCount.type
      }
    },
    data () {
      return {
        datas:'',
        thisname:'',
        point:this.$route.params.point,
        readlist:JSON.parse(this.$route.params.readlist),
      }
    },
    methods:{
        login:function () {
          var isUser = localStorage.getItem("BLHuser")
          this.$api.post('WebApi/Login/Index/select_login', {token: isUser}, res => {
            if (res.data.errCode == '0000') {
            } else {
              this.$router.push({path: '/login'})
            }
          })
        },
        go:function (a) {
          window.location.href = a;
        }
    },
    mounted () {
        this.login
    },
  }
</script>

<style lang="less" scoped>
  .userindex{
    .van-content{
      padding-top: 0;
    }
    .userbanner{
      height: 190px;
      position: relative;
      .userbox{
        padding-top: 45px;
        text-align: center;
        .vipname{
          background: #fb4141;
          padding: 4px 6px;
          border-radius: 6px;
          margin-right: 7px;
        }
        .name{
          font-size: 2rem;
        }
        .vipjif{
          margin-top: 5px;
          font-size: 1.6rem;
          color: #fff;
        }
        img{
          width: 70px;
          height: 70px;
          vertical-align: top;
          margin-right: 5px;
          border-radius: 50%;
        }
        .userInfo{
          display: inline-block;
          padding-top: 9px;
          p{
            color: #fff;
          }
        }
        .userInfo.will{
          padding-top: 0px;
          display: inline-block;
          p{
            color: #fff;
          }
        }
      }
      .signintag{
        background: #fa2924;
        width: 60px;
        display: inline-block;
        position: absolute;
        z-index: 1;
        right: 0;
        margin-top: 40px;
        overflow: hidden;
        border-radius: 16px 0 0 16px;
        box-shadow: 0px 1px 6px -1px #333;
      }

    }
    .van-cell:not(:last-child)::after{
      left: 0;
    }
    .userOrder{
      position: relative;
    }
    .van-cell-group,.van-cell{
      background: #fff;
    }
    .ordercell{
      img{
        width: 25px;
        height: auto;
        margin-bottom: 5px;
      }
    }
    .van-cell-group{
      .van-cell__title{
        img{
          width: 30px;
          margin-right: 5px;
        }
      }
    }
    .tell{
      vertical-align: -webkit-baseline-middle;
    }
    .van-col--6 {
      text-align: center;
      height: 25vw;
      padding: 4%;
      background-color: #fff;
      border-right: 1px solid #EEEEEE;
      position: relative;
      p{
        text-align: center!important;
        width: 70px;
        position: absolute;
        left: 50%;
        margin-left: -35px;
      }
    }
    .van-col--6 img{
      width: 80%;
      height: 12vw;
    }

    .van-cell-group {
      margin-bottom: 0px;
      border-bottom: 1px solid #EEEEEE;
    }
    @media screen and (device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2){
      .van-col--6 {
        padding: 3%;
      }
    }
    .contolButton{
      [class*=van-hairline]::after {
        border: 0 solid transparent;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/read/read.vue